import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/simak.svg';
import './Header.scss';

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className="header">
        <div className="container">
          <nav className="navbar">
            <div className="logo">
              <Link to="/" onClick={closeMenu}>
                <img src={logo} alt="Simak Logo" className="logo-image" />
              </Link>
            </div>

            {/* Desktop nav */}
            <div className="nav-menu desktop-nav">
              <ul className="nav-links">
                <li className="nav-item">
                  <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
                </li>
                <li className="nav-item">
                  <Link to="/services" className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`}>Services</Link>
                </li>
                <li className="nav-item">
                  <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>About Us</Link>
                </li>
                <li className="nav-item">
                  <Link to="/careers" className={`nav-link ${location.pathname === '/careers' ? 'active' : ''}`}>Careers</Link>
                </li>
                <li className="nav-item contact-button">
                  <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
                </li>
              </ul>
            </div>

            {/* Hamburger button — mobile only */}
            <button
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              onClick={toggleMenu}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            >
              {menuOpen ? (
                <span className="icon-x">&#10005;</span>
              ) : (
                <span className="icon-bars">
                  <span /><span /><span />
                </span>
              )}
            </button>
          </nav>
        </div>
      </header>

      {/* Overlay */}
      <div
        className={`drawer-overlay ${menuOpen ? 'visible' : ''}`}
        onClick={closeMenu}
      />

      {/* Slide-in Drawer */}
      <nav className={`mobile-drawer ${menuOpen ? 'open' : ''}`}>
        <ul className="drawer-links">
          <li>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/services" className={location.pathname === '/services' ? 'active' : ''} onClick={closeMenu}>
              Services
            </Link>
          </li>
          <li>
            <Link to="/about" className={location.pathname === '/about' ? 'active' : ''} onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/careers" className={location.pathname === '/careers' ? 'active' : ''} onClick={closeMenu}>
              Careers
            </Link>
          </li>
          <li className="drawer-contact">
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;